export default __webpack_public_path__ + "static/Tapejara_Tek_Saddle-49b2e8a3a11a4b8076f0ef944eb13463.png";